import { focusInput } from '../../client/components/search/searchInput';
import getPdfViewerApplication from '../../client/utils/pdfjs/pdfViewerApplication';
import {
  CANCEL_SEARCH,
  FIND_IN_DOCUMENT,
  NAVIGATE_TO_OCCURRENCE,
  OPEN_SEARCH,
} from './types';
import { DIRECTION, KEYCODE_F3, KEYCODE_F } from '../../client/constants';
import { trackAdobeFeature } from '../../client/utils/trackers/adobe';

export const goToOccurrence = (dispatch, find, direction) => {
  const { query, matchCount } = find;
  if (!matchCount) { return; }

  if (DIRECTION.DESC === direction) {
    getPdfViewerApplication().findApi.findPrevious(query);
  } else {
    getPdfViewerApplication().findApi.findNext(query);
  }

  dispatch({
    type: NAVIGATE_TO_OCCURRENCE,
    payload: { direction },
  });
};

export default function submitQuery(query, direction = DIRECTION.ASC) {
  return async (dispatch, getState) => {
    const { find } = getState();
    const { query: previousQuery } = find;

    if (query === previousQuery) {
      return goToOccurrence(dispatch, find, direction);
    }
    getPdfViewerApplication().findApi.find(query, direction);
    return dispatch({
      type: FIND_IN_DOCUMENT,
      payload: { query, direction },
    });
  };
}

export function cancelSearch() {
  trackAdobeFeature('search-closed');
  return (dispatch) => {
    getPdfViewerApplication().findApi.cancelFind();
    dispatch({ type: CANCEL_SEARCH });
  };
}

function isFindEvent(event) {
  return event.keyCode === KEYCODE_F3
    || ((event.ctrlKey || event.metaKey) && event.keyCode === KEYCODE_F);
}

export function attachHotkeyInterceptors() {
  return (dispatch) => {
    window.addEventListener('keydown', (e) => {
      if (isFindEvent(e)) {
        e.preventDefault();
        dispatch({ type: OPEN_SEARCH });
        focusInput();
      }
    });
  };
}

export function goToNext() {
  return (dispatch, getState) => {
    const { find } = getState();
    return goToOccurrence(dispatch, find, DIRECTION.ASC);
  };
}

export function goToPrev() {
  return (dispatch, getState) => {
    const { find } = getState();
    return goToOccurrence(dispatch, find, DIRECTION.DESC);
  };
}
